import React, { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import IwMenu from "../../../app/IwMenu";

export const ActionCell = ({...props}) => {
   const {
    row,
    setOpenPendingUserActionModal,
    setTitle,
    setSingleUserData
  } = {...props}

  return (
    <>

      <IwMenu
        label={<MoreVertIcon fontSize="medium" />}
        tooltipProps={{ title: "Options" }}
        items={[
          {
            id: "resend",
            label: "Resend",
            onClick: () => {
                setOpenPendingUserActionModal(true)
                setSingleUserData(row.original)
                setTitle("Resend Invite")
            },
          },
          { id: "cancel", 
            label: "Cancel", 
            onClick: () => {
                setOpenPendingUserActionModal(true)
                setSingleUserData(row.original)
                setTitle("Cancel Invite")
            } 
          },
          {
            id: "reserveToken",
            label: "Reserve token",
            onClick: () => {
                setOpenPendingUserActionModal(true)
                setSingleUserData(row.original)
                setTitle("Reserve token")
            },
          },
        ]}
      />
    </>
  );
};
 
